import type {Migrator} from './componentMigration'
import type {SerializedCompStructure, StyleRef} from '@wix/document-services-types'
import _ from 'lodash'

export const recursifyMigrator = (migrator: Migrator): Migrator => {
    const recursiveMigrator = (serializedComponent: SerializedCompStructure) => {
        if (serializedComponent.components && !_.isEmpty(serializedComponent.components)) {
            _.forEach(serializedComponent.components, (component: SerializedCompStructure) =>
                recursiveMigrator(component)
            )
        }
        migrator(serializedComponent)
    }
    return recursiveMigrator
}

const counter = {}
export const generateUniqueId = (prefix: string) => {
    if (counter[prefix]) {
        return `${prefix}-cm-${++counter[prefix]}`
    }
    counter[prefix] = 0
    return `${prefix}-cm-${++counter[prefix]}`
}

export const isStyleRef = (styleObject?: unknown): styleObject is StyleRef =>
    !!styleObject && styleObject.hasOwnProperty('style')
